import Swiper from 'swiper/bundle';
import "swiper/css/bundle";

class HomepageSpecProjects {
	static block_name = "b-homepage-spec-projects";

	constructor($elem) {
		this.$elem = $elem;
	}

	onInit() {
		const it = this;

		const items = it.$elem.find(`.${HomepageSpecProjects.block_name}__items`).get(0);
		const swiper_items = new Swiper(items, {
			loop: true,
			centeredSlides: true,
			slidesPerView: 1,
			loopedSlides: 5,
			loopedSlidesLimit: false,
			spaceBetween: 20,
			slideToClickedSlide: true, // не работает из-за отключенного simulateTouch
			simulateTouch: false,

			controller: {
				by: 'container',
			},

			breakpoints: {
				1200: {
					slidesPerView: 3,
					spaceBetween: 0,
				},
				1400: {
					slidesPerView: 5,
					spaceBetween: 0,
				},
			},

			on: {
				slideChange: function () {
					var activeIndex = this.activeIndex;

					this.slides.removeClass('swiper-slide-nth-prev-2 swiper-slide-nth-next-2 swiper-slide-nth-prev-3 swiper-slide-nth-next-3');
					this.slides.eq(activeIndex).prev().prev().addClass('swiper-slide-nth-prev-2');
					this.slides.eq(activeIndex).next().next().addClass('swiper-slide-nth-next-2');
					this.slides.eq(activeIndex).prev().prev().prev().addClass('swiper-slide-nth-prev-3');
					this.slides.eq(activeIndex).next().next().next().addClass('swiper-slide-nth-next-3');
				},
			}
		});

		const items_text = it.$elem.find(`.${HomepageSpecProjects.block_name}__text`).get(0);
		const swiper_text = new Swiper(items_text, {
			loop: true,
			centeredSlides: true,
			slidesPerView: 1,
			loopedSlides: 5,
			loopedSlidesLimit: false,
			spaceBetween: 20,
			simulateTouch: false,

			controller: {
				by: 'container',
			},

			breakpoints: {
				1200: {
					spaceBetween: 0,
				},
			},

			navigation: {
				prevEl: this.$elem.find(`.${HomepageSpecProjects.block_name}__navigation-prev`).get(),
				nextEl: this.$elem.find(`.${HomepageSpecProjects.block_name}__navigation-next`).get(),
			},
		});

		swiper_items.controller.control = swiper_text;
		swiper_text.controller.control = swiper_items;

		$(window).resize(function(){
			setTimeout(function() {
				swiper_items.slideNext(0, false);
				swiper_items.slidePrev(0, false);
				swiper_text.update();
				swiper_items.update();
			}, 200);
		});

		// Кастомная реализация slideToClickedSlide, т.к. он перестал работать при отключенной опции simulateTouch (свайп мышью на десктопе)
		it.$elem.find(`.${HomepageSpecProjects.block_name}__project`).addClass('FFFF').on('click', function(){
			let $parent = $(this).closest('.b-homepage-spec-projects__item');
			if($parent.hasClass('swiper-slide-active')) {
				it.$elem
				.find(`.${HomepageSpecProjects.block_name}__text-item.swiper-slide-active`)
				.find(`.${HomepageSpecProjects.block_name}__text-item-link`).get(0).click();
			}
			swiper_items.updateClickedSlide($parent.get(0));
		});
	}
}

export default HomepageSpecProjects;
